module.exports = __webpack_public_path__ + "static/media/graph.72327400.png";